import { FocusMonitor } from '@angular/cdk/a11y';
import { Component, Inject, ViewChild } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Coordinate } from 'src/app/data-models/coordinate.model';

@Component({
    selector: 'app-coordinate-dialog',
    templateUrl: './coordinate-dialog.component.html',
    styleUrls: ['./coordinate-dialog.component.css'],
    standalone: false
})
export class CoordinateDialogComponent {
  /*
    latitude:
    min: 38D 00.00M North  == 38.0000
    max: 72D 00.00M North  == 72.0000

    longitude:
    min: 148D 00.00M West  == -148.0000
    max: 40D 00.00M West   == -40.0000
  */
  @ViewChild('deg') degInput!: HTMLInputElement;
  @ViewChild('min') minInput!: HTMLInputElement;
  @ViewChild('minDec') minDecInput!: HTMLInputElement;

  latLonLen = this.data.title == 'longitude' ? 3 : 2;
  
  degrees = new FormControl(''); //If latitude: max is 38 degrees 00.00 minutes, min
  minutes = new FormControl('');
  decimalMinutes = new FormControl('00');
  seconds = new FormControl('');

  constructor(public dialogRef: MatDialogRef<CoordinateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {title: string, coord: Coordinate}, 
    private _focusMonitor: FocusMonitor) { }

    ngOnInit(): void {
      let mins = Math.floor(this.data.coord.minutes);
      this.degrees.setValue(this.data.coord.degrees ? this.data.coord.degrees.toString() : '');
      this.minutes.setValue(mins ? mins.toString() : '');
      this.decimalMinutes.setValue(this.data.coord.minutes ? this.data.coord.minutes.toString().substring(3) : '');
    }

  /**
   * Jump from degrees to minutes, minutes to seconds when their fields are filled
   * @param control 
   * @param limit 
   * @param nextElement 
   */
  _handleInput(control: AbstractControl, limit: number, nextElement?: HTMLInputElement): void {
    this._forbidNonNumeric(control);
    let next = (control.value as string).length == limit;
    if (!control.errors && nextElement && next) {
      this._focusMonitor.focusVia(nextElement, 'program');
    }
  }

  
  onConfirm() {
    let coord = new Coordinate;
    coord.degrees = this.degrees.value ? Number.parseInt(this.degrees.value) : this.data.coord.degrees;
    coord.minutes = this.minutes.value ? Number.parseFloat(this.minutes.value + '.' + this.decimalMinutes.value) : this.data.coord.minutes;
    coord.decimal = Number.parseFloat((coord.degrees + coord.minutes/60.0).toFixed(4)) * (this.data.title == 'longitude' ? -1 : 1);
    coord.isEnteredManually = true;
    this.dialogRef.close(coord)
  }

  _forbidNonNumeric(control: AbstractControl) {
    control.setValue(control.value.replace(/[^0-9]/g, ''), {onlySelf: true, emitEvent: false});
  }
}
